import { TieredMenu } from "primereact/tieredmenu";
import React, { useMemo, useRef, useState } from "react";
import { WSElement } from "../WSElement/WSElement.component";
import {
  WSMenu,
  WSMenuBasicItem,
  WSMenuCommandEvent
} from "../common/WSMenu/WSMenu.component";
import { WSButton } from "../core/WSButton/WSButton.component";
import { WSIcon } from "../core/WSIcon/WSIcon.component";
import styles from "./WSTable.module.scss";
import { WSTableItem, WSTableRowActions, WSTableRowMenuActions } from "./types";

type RowActionsProps = {
  item: WSTableItem;
  rowMenuActions?: WSTableRowMenuActions<any>;
  rowActions?: WSTableRowActions<any>;
  onRowClick?: (item: WSTableItem) => void;
  disabled?: boolean;
};

export const RowActions: React.FC<RowActionsProps> = ({
  item,
  rowActions,
  rowMenuActions,
  onRowClick,
  disabled
}) => {
  const actions = rowActions?.(item);
  const menuActions = rowMenuActions?.(item);
  const handleRowClick = onRowClick ? () => onRowClick?.(item) : undefined;
  const menuRef = useRef<TieredMenu>(null);
  const [menuActionsLoading, setMenuActionsLoading] = useState(false);

  const mappedMenuActions = useMemo(() => {
    return menuActions?.map((action) => ({
      ...action,
      onClick: async (event: WSMenuCommandEvent) => {
        if (action.onAsyncClick) {
          setMenuActionsLoading(true);
          try {
            await action.onAsyncClick?.();
          } catch (error) {
            console.error(error);
          }
          setMenuActionsLoading(false);
        } else {
          (action as WSMenuBasicItem).onClick?.(event);
        }
      }
    }));
  }, [menuActions]);

  return (
    <>
      {mappedMenuActions && mappedMenuActions.length > 0 && (
        <WSMenu ref={menuRef} name="tableRow" items={mappedMenuActions} />
      )}

      <WSElement className={styles.rowActions}>
        {actions &&
          actions.map((action, index) => (
            <WSButton.Link
              size="S"
              type="button"
              key={action.text + String(index)}
              onClick={action.onClick}
              onAsyncClick={action.onAsyncClick}
              disabled={disabled}
            >
              {action.text}
            </WSButton.Link>
          ))}

        {mappedMenuActions && mappedMenuActions.length > 0 && (
          <WSIcon
            onClick={
              menuActionsLoading || disabled
                ? undefined
                : (event) => {
                    menuRef.current?.toggle(event);
                  }
            }
            block
            name={menuActionsLoading ? "loader" : "dots-v"}
            color={disabled ? "gray300" : "gray500"}
            size="S"
          />
        )}

        {!!handleRowClick && (
          <WSIcon
            onClick={handleRowClick}
            block
            name="chevron-right"
            color="gray500"
            size="S"
          />
        )}
      </WSElement>
    </>
  );
};
